<h2 mat-dialog-title class="mat-h1">
    <mat-icon class="success-ic success-popup-title-icon" href="javascript:void(0)">check_circle</mat-icon>
    {{ config?.title }} 
    <button mat-icon-button class="close-button" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content> 
    <p class="mat-subtitle-1">Thank you for your submission.</p>
    <p>Please include printed submission form with your shipment.</p>
    <p>For any questions regarding your submission, please contact <a href="mailto:questions@geothermusa.com">questions&#64;geothermusa.com</a>.</p>
  </mat-dialog-content>
  <mat-divider></mat-divider>
  <mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="closeDialog()">CLOSE</button>
  </mat-dialog-actions>
  
 